import React, { MouseEvent } from 'react';

import * as S from './TextButton.styles';

export type TextButtonProps = {
  text: string;
  iconSrc?: string;
  onClick?: (e: MouseEvent) => void;
  className?: string;
};

export const TextButton = ({
  text,
  iconSrc,
  onClick,
  className,
}: TextButtonProps) => {
  return (
    <S.TextButtonStyled onClick={onClick} type='button' className={className}>
      {!!iconSrc && <S.StyledIcon src={iconSrc} alt='Text button icon' />}
      <S.Text>{text}</S.Text>
    </S.TextButtonStyled>
  );
};
